export const bookSort = {
  10001: {
    name: "新版 标准日本语（第二版）初级",
    imgName: "brcj.png",
    series: "brdzs",
  },
  10002: {
    name: "新版 标准日本语（第二版）中级",
    imgName: "brzj.png",
    series: "brdzs",
  },
  10003: {
    name: "新版 标准日本语（第二版）高级",
    imgName: "brgj.png",
    series: "brdzs",
  },
  10004: {
    name: "标准日本语初级同步练习",
    imgName: "brlxcj.png",
    series: "brdzslx",
  },
  10005: {
    name: "标准日本语中级同步练习",
    imgName: "brlxzj.png",
    series: "brdzslx",
  },
  10006: {
    name: "标准日本语高级同步练习",
    imgName: "brlxgj.png",
    series: "brdzslx",
  },
  10007: {
    name: "高考日语突破听力强化",
    imgName: "gkrytlqh.png",
    series: "gaokao",
  },
  10008: {
    name: "高考日语突破模拟测试",
    imgName: "gkrymscs.png",
    series: "gaokao",
  },
  10009: {
    name: "七年级日语教材同步练习",
    imgName: "rytblx7.png",
    series: "yiwu",
  },
  10010: {
    name: "八年级日语教材同步练习",
    imgName: "rytblx8.png",
    series: "yiwu",
  },
  10011: {
    name: "九年级日语教材同步练习",
    imgName: "rytblx9.png",
    series: "yiwu",
  },
  10012: {
    name: "（首版）标准日本语初级",
    imgName: "sb_br_cj.png",
    series: "sbbrdzs",
  },
  10013: {
    name: "（首版）标准日本语中级",
    imgName: "sb_br_zj.png",
    series: "sbbrdzs",
  },
  10014: {
    name: "义务教育教科书 日语 七年级 全一册",
    imgName: "ryjks7.png",
    series: "yiwujks",
  },
  10015: {
    name: "标准日本语 初级 会话篇",
    imgName: "bookshelf_huihua.png",
    series: "brhhp",
  },
  10016: {
    name: "新版 中日交流标准日本语（第三版）初级",
    imgName: "br3cj.png",
    series: "br3dzs",
  },
  10017: {
    name: "新版 中日交流标准日本语（第三版）中级",
    imgName: "br3zj.png",
    series: "br3dzs",
  },
  10018: {
    name: "新版 中日交流标准日本语（第三版）高级",
    imgName: "br3gj.png",
    series: "br3dzs",
  },
  10021: {
    name: "高考日语突破 听力训练",
    imgName: "gkrytlxl.png",
    series: "gaokao",
  },
  10022: {
    name: "高考日语突破 模拟试题",
    imgName: "gkrymnst.png",
    series: "gaokao",
  },
};
